import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Banner.module.css';
import BackgroundShadow from '../shared/BackgroundShadow';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';
import image from './images/Group.png';

const Banner: React.FC = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, []);

    return (
        <div className={styles.container}>
            <BackgroundShadow />

            <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                Teamwork
            </OptimizedMotionH1>
            <OptimizedMotionP className={styles.description} type="slide-down" delay={0.4}>
                Teamwork brings creators, marketers, and stakeholders together in one unified
                workspace—enabling real-time collaboration, task assignment, and seamless
                communication to move projects forward faster and smarter.
            </OptimizedMotionP>

            <img src={image} alt="banner" className={styles.image} />
        </div>
    );
};

export default Banner;
